import { useState } from "react";
import { google } from "../assets";
import { Header } from "../components";
import { useAuth } from "../context/AuthContext";
import About from "./About";

const Login = () => {
  const { logInWithGoogle } = useAuth();
  const [isAbout, setIsAbout] = useState(false);

  const handleLogin = async () => {
    await logInWithGoogle();
  };

  return (
    <>
      <Header handleAboutButton={() => setIsAbout(!isAbout)} isAbout={isAbout} />
      <section className={`container-body ${isAbout ? "" : "login"}`}>
        {isAbout ? (
          <About />
        ) : (
          <>
            <h3>Welcome to the collaborative bookmark tool!</h3>
            <button
              className='flex login-provider'
              style={{ fontSize: 18 }}
              onClick={handleLogin}
            >
              <img src={google} alt='google' style={{ marginRight: 8 }} />
              Continue with Google
            </button>
            <span onClick={() => setIsAbout(true)}>About Cloudmark</span>
          </>
        )}
      </section>
    </>
  );
};

export default Login;
